/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-15 12:00:23
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-29 15:35:05
 * @FilePath: /unifyxp-v2-store-portal/src/components/SettingsPage/index.tsx
 */
import React from 'react';
import { useHistory } from 'react-router';

import { Icon } from '@/src/tools/icon';
import { Breadcrumb } from '@/src/components/Antd';
import { Row, Col } from 'antd';

import styles from './style.module.less';
// const JSON13 = 'https://resource2.unifyxp.com/test/smaple.json';
// const JSON7 = 'https://resource2.unifyxp.com/test/7.json';
// const JSON25 = 'https://resource2.unifyxp.com/test/25.json';
// import axios from 'axios';
const SettingsPage = ({ breadcrumbData, settings }) => {
  const history = useHistory();
  // axios.get(JSON25).then((res) => {
  //   console.log(res);
  // });
  const handleClick = (link: string) => history.push(link);
  return (
    <div className={styles.container}>
      <div className={styles.breadcrumb}>
        <Breadcrumb
          className={styles.breadcrumb}
          breadcrumbData={breadcrumbData}
        />
      </div>
      <div className={styles.content}>
        <Row gutter={[24, 16]} style={{ width: '100%' }}>
          {settings.map((setting, index) => {
            return (
              <Col span={6} key={index} id={setting.name}>
                <div
                  className={styles.card}
                  onClick={handleClick.bind(this, setting.linkTo)}>
                  <div className={styles.left}>
                    <Icon type={setting.icon} className={styles.icon} />
                  </div>
                  <div className={styles.right}>
                    <div className={styles.name}>{setting.name}</div>
                    <div
                      className={styles.desc}
                      dangerouslySetInnerHTML={{ __html: setting.desc }}></div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};
export default SettingsPage;
